import { type FormEvent, useEffect, useState } from 'react'
import { api, type Benutzer as BenutzerDaten, type Rolle } from '../api'
import { Dialog, Fehlermeldung, fehlerText } from './gemeinsam'

export function Benutzer({ angemeldet }: { angemeldet: string }) {
  const [benutzer, setBenutzer] = useState<BenutzerDaten[]>([])
  const [fehler, setFehler] = useState<string | null>(null)
  const [meldung, setMeldung] = useState<string | null>(null)
  const [neu, setNeu] = useState(false)

  const laden = () => api.benutzer().then(setBenutzer).catch((e) => setFehler(fehlerText(e)))
  useEffect(() => {
    laden()
  }, [])

  async function aktion(f: () => Promise<unknown>, erfolg: string) {
    setFehler(null)
    setMeldung(null)
    try {
      await f()
      setMeldung(erfolg)
      await laden()
    } catch (e) {
      setFehler(fehlerText(e))
    }
  }

  return (
    <section className="karte">
      <div className="werkzeuge">
        <h2>Benutzer</h2>
        <button className="primaer" onClick={() => setNeu(true)}>
          Einladen
        </button>
      </div>
      <Fehlermeldung fehler={fehler} />
      {meldung && <p className="hinweis">{meldung}</p>}
      <table>
        <thead>
          <tr>
            <th>Benutzername</th>
            <th>E-Mail</th>
            <th>Rolle</th>
            <th>Status</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {benutzer.map((b) => (
            <tr key={b.id}>
              <td>{b.benutzername}</td>
              <td>
                {b.email ?? <span className="hinweis">–</span>}
                {b.email && !b.emailVerifiziert && <span className="marke">nicht bestätigt</span>}
              </td>
              <td>{b.rolle === 'ADMIN' ? 'Admin' : 'Benutzer'}</td>
              <td>{b.aktiv ? 'aktiv' : 'eingeladen'}</td>
              <td className="aktionen">
                {!b.aktiv && (
                  <button className="link" onClick={() => aktion(() => api.einladungSenden(b.id), `Einladung an ${b.email} verschickt.`)}>
                    Einladung erneut senden
                  </button>
                )}
                {b.benutzername !== angemeldet && (
                  <button
                    className="link gefahr"
                    onClick={() => confirm(`Benutzer ${b.benutzername} löschen?`) && aktion(() => api.benutzerLoeschen(b.id), `${b.benutzername} gelöscht.`)}
                  >
                    Löschen
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <Dialog offen={neu} titel="Benutzer einladen" onSchliessen={() => setNeu(false)}>
        <Einladung
          onAngelegt={(b) => {
            setNeu(false)
            setMeldung(`${b.benutzername} angelegt, Einladung an ${b.email} verschickt.`)
            laden()
          }}
        />
      </Dialog>
    </section>
  )
}

function Einladung({ onAngelegt }: { onAngelegt: (b: BenutzerDaten) => void }) {
  const [benutzername, setBenutzername] = useState('')
  const [email, setEmail] = useState('')
  const [rolle, setRolle] = useState<Rolle>('USER')
  const [fehler, setFehler] = useState<string | null>(null)

  async function absenden(e: FormEvent) {
    e.preventDefault()
    setFehler(null)
    try {
      onAngelegt(await api.benutzerAnlegen({ benutzername, email, rolle }))
    } catch (err) {
      setFehler(fehlerText(err))
    }
  }

  return (
    <form className="formular" onSubmit={absenden}>
      <label>
        Benutzername
        <input value={benutzername} onChange={(e) => setBenutzername(e.target.value)} autoFocus />
      </label>
      <label>
        E-Mail-Adresse
        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
      </label>
      <fieldset className="radios">
        <label>
          <input type="radio" checked={rolle === 'USER'} onChange={() => setRolle('USER')} /> Benutzer
        </label>
        <label>
          <input type="radio" checked={rolle === 'ADMIN'} onChange={() => setRolle('ADMIN')} /> Admin
        </label>
      </fieldset>
      <p className="hinweis">Der Benutzer bekommt eine Mail mit einem Link, über den er sein Passwort vergibt. Der Link ist 7 Tage gültig.</p>
      <Fehlermeldung fehler={fehler} />
      <div className="knoepfe">
        <button type="submit" className="primaer" disabled={!benutzername || !email}>
          Anlegen und einladen
        </button>
      </div>
    </form>
  )
}
